import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { OrgService } from 'src/app/_services/org.service';
import { Subscription } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Role } from 'src/app/_helpers/roles';

@Component({
	selector: 'export-data-card',
	templateUrl: './export-data-card.component.html',
	styleUrls: ['./export-data-card.component.css'],
})
export class ExportDataCardComponent implements OnInit, OnChanges {
	constructor(public orgService: OrgService) {}
	@Input() node: any = 0;
	list: any;
	subscriptions: Subscription[] = [];

	ngOnInit(): void {
		if (this.node?.id) {
			this.loadTreeData();
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['node'] && !changes['node'].firstChange && this.node?.id) {
			this.subscriptions.forEach((sub) => sub.unsubscribe());
			this.subscriptions = [];
			this.loadTreeData();
		}
	}

	loadTreeData(): void {
		if (this.node?.id) {
			this.subscriptions.push(
				this.orgService.tree$(this.node.id).subscribe((data: any) => {
					this.list = [data];
					if (this.list.length > 0) {
						this.list[0].expanded = true;
					}
				})
			);
		}
	}

	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
}
